import { type DateObject, type NetworkType } from '@capsicum/common';
import { type CardProps, NetworkIcon, SkeletonItem } from '@capsicum/common-web';

import {
	CollectibleCardMediaSkeleton,
	CollectibleCardWrapper,
	CollectibleWrapper,
	IconWrapper,
	MediaWrapper,
	SkeletonWrapper,
	TextWithEllipsis
} from './CollectibleCard.styles';

export type CollectibleCardProps = CardProps & {
	availableAt?: DateObject;
	backgroundImageUrl: string;
	interactive?: boolean;
	network: NetworkType;
	nftImageUrl: string;
	onActivate?: () => void;
	optionType?: string;
	status?: string;
	subtitle: string;
	title: string;
};

// CollectibleCard skeleton
export const CollectibleCardSkeleton = () => (
	<SkeletonWrapper>
		<CollectibleCardMediaSkeleton />
		<CollectibleCardWrapper.Content>
			<CollectibleCardWrapper.Title>
				<SkeletonItem height="12px" width="50%" />
			</CollectibleCardWrapper.Title>
			<CollectibleCardWrapper.SubTitle>
				<SkeletonItem height="12px" width="100%" />
			</CollectibleCardWrapper.SubTitle>
		</CollectibleCardWrapper.Content>
	</SkeletonWrapper>
);

export const CollectibleCard = ({
	backgroundImageUrl,
	interactive = true,
	network,
	nftImageUrl,
	onActivate,
	subtitle,
	title,
	...props
}: CollectibleCardProps) => {
	const handleClick = () => {
		onActivate?.();
	};

	return (
		<CollectibleCardWrapper {...props} $interactive={interactive} onActivate={handleClick}>
			<MediaWrapper $backgroundImage={backgroundImageUrl}>
				<IconWrapper>
					<NetworkIcon color="white" network={network} />
				</IconWrapper>
				<CollectibleWrapper $backgroundImage={nftImageUrl} />
			</MediaWrapper>
			<CollectibleCardWrapper.Content>
				<CollectibleCardWrapper.Title>
					<TextWithEllipsis variant="title1">{title}</TextWithEllipsis>
				</CollectibleCardWrapper.Title>
				<CollectibleCardWrapper.SubTitle>
					<TextWithEllipsis variant="title1">{subtitle}</TextWithEllipsis>
				</CollectibleCardWrapper.SubTitle>
			</CollectibleCardWrapper.Content>
		</CollectibleCardWrapper>
	);
};
